<template>
  <div class="shop_login">
    <div class="shop_top">
      <shop-top :subnav_show="false" :show_nav="false" :change_color="true"></shop-top>
    </div>
    <div class="shop_login_bg" :style="'background:url('+login_adv+')'">
      <div class="shop_login_block width_center_1200">
        <div class="login_block">
          <div class="login_title">
            <ul>
              <li
                :class="{'colors': login_type === 0 }"
                @click="login_type = 0"
              >{{ lang.pwd_login }}</li>
              <li
                :class="{'colors': login_type === 1 }"
                @click="login_type = 1"
              >{{ lang.code_login }}</li>
            </ul>
          </div>
          <div class="code-box" @click="scanWxCode">
            <p>{{ lang.scan_code_login }}</p>
            <i class="el-icon-caret-right" />
            <img src="../../assets/images/wechat_code.png" alt />
          </div>
          <div class="login_input">
            <div class="input_block">
              <svg-icon iconClass="phone" />
              <select v-if="login_type === 1" v-model="info.phoneprefix">
                <option value="853">853</option>
                <option value="86">86</option>
              </select>
              <input
                type="text"
                @keyup.enter="to_login"
                v-model="info.phone"
                :placeholder="lang.phone"
              />
            </div>
            <div v-show="login_type === 0" class="input_block">
              <svg-icon iconClass="password" />
              <input
                type="password"
                @keyup.enter="to_login"
                v-model="info.loginpwd"
                placeholder="********"
              />
            </div>
            <div v-show="login_type === 1" class="input_block">
              <svg-icon iconClass="password" />
              <input
                type="number"
                @keyup.enter="to_login"
                v-model="info.code"
                :placeholder="lang.code_tips"
              />
              <div v-show="showCode" class="btn" @click="send_sms()">{{ lang.get_code }}</div>
              <div v-show="!showCode" class="btn disabled">{{ lang.sent }}{{ count }}s</div>
            </div>
          </div>
          <div class="login_btn" @click="to_login">
            <router-link to="#">{{ lang.login }}</router-link>
          </div>

          <div class="tips">
            {{ lang.protocol_text1 }}
            <router-link to="/parse?key=loginuserkey">{{ lang.protocol_text2 }}</router-link>
            {{ lang.protocol_text3 }}
            <router-link to="/parse?key=loginuserPrivacykey">{{ lang.protocol_text4 }}</router-link>
          </div>

          <div class="login_btn_b">
            <router-link to="/forget">{{ lang.forget_pwd }}</router-link>
            <router-link to="/register">{{ lang.register }}</router-link>
          </div>
        </div>
      </div>
    </div>
    <shop-foot></shop-foot>
  </div>
</template>

<script>
import ShopTop from '@/components/ShopHead/index.vue'
import ShopFoot from '@/components/ShopFoot/index.vue'
import { loginbypwd, loginbyphone } from '@/api/login'
import { sendmsg } from '@/api/home'
export default {
  components: {
    ShopTop,
    ShopFoot
  },
  computed: {
    lang() {
      return this.$t('login')
    }
  },
  data() {
    return {
      login_adv: require('../../assets/images/login_bg.png'),
      login_type: 0,
      info: {
        phone: '',
        loginpwd: '',
        code: '',
        phoneprefix: '853'
      },
      showCode: true,
      count: 60,
      timer: null
    }
  },
  created() {
    this.getCodeLogin()
  },
  methods: {
    // 发送短信
    async send_sms() {
      if (this.$isEmpty(this.info.phone)) {
        return this.$message.error(this.$t('login').phone_tips)
      }
      if (this.info.phoneprefix === '853') {
        if (!this.$macao_phone.test(this.info.phone)) {
          this.$message.error(this.$t('login').phone_regular_tips)
          return
        }
      } else {
        if (!this.$phone_str.test(this.info.phone)) {
          this.$message.error(this.$t('login').phone_regular_tips)
          return
        }
      }
      await sendmsg({
        phoneprefix: this.info.phoneprefix,
        phone: this.info.phone,
        tempcode: 'a3'
      })
      // 验证码倒计时
      if (!this.timer) {
        this.count = 60
        this.showCode = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= 60) {
            this.count--
          } else {
            this.showCode = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },
    getLoginData() {
      const password = this.info.password
      return {
        username: this.info.username,
        password: password
      }
    },
    to_login() {
      if (this.$isEmpty(this.info.phone)) {
        return this.$message.error(this.$t('login').phone_tips)
      }
      if (this.login_type === 0) {
        if (this.$isEmpty(this.info.loginpwd)) {
          return this.$message.error(this.$t('login').pwd_tips)
        }
        loginbypwd({
          phone: this.info.phone,
          loginpwd: this.info.loginpwd
        }).then(async (res) => {
          await this.$store.dispatch('login', res.data.uid)
          this.$message.success(res.msg)
          this.$router.push('/')
        })
      } else {
        if (this.$isEmpty(this.info.code)) {
          return this.$message.error(this.$t('login').code_tips)
        }
        loginbyphone({
          phone: this.info.phone,
          code: this.info.code
        }).then(async (res) => {
          await this.$store.dispatch('login', res.data.uid)
          this.$message.success(res.msg)
          this.$router.push('/')
        })
      }
    },
    scanWxCode() {
      let iWidth = 540
      let iHeight = 540
      let iTop = (window.screen.availHeight - 30 - iHeight) / 2
      let iLeft = (window.screen.availWidth - 10 - iWidth) / 2
      window.open(
        'http://shopapi.katkatmall.com/wxloginv1/LoginToPCWx?CallbackUrl=%2Flogin',
        '微信登录',
        'width=540,height=540,top= ' + iTop + ',left= ' + iLeft
      )
    },
    async getCodeLogin() {
      const uid = this.$route.query.uid
      if (uid) {
        if (window.opener) {
          window.opener.location.replace(location.href)
          window.close()
          return false
        } else {
          if (parseInt(this.$route.query.ckuser) === 0) {
            this.$router.push(`/register?uid=${uid}`)
            return
          }
          this.$store.dispatch('login', uid)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.shop_login_bg {
  height: 647px;
}

.login_left {
  float: left;
  width: 50%;
  box-sizing: border-box;
  height: 550px;
}

.login_block {
  position: relative;
  width: 460px;
  padding: 0 24px;
  background: #fff;
  border-radius: 12px;
  float: right;
  box-sizing: border-box;
  margin: 160px 60px 0 0;
  .code-box {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    cursor: pointer;
    p {
      padding-top: 10px;
      color: #ec9221;
      font-size: 14px;
    }
    i {
      padding-top: 12px;
      color: #ec9221;
    }
    img {
      width: 60px;
      height: 60px;
    }
  }
  .login_title {
    height: 71px;
    line-height: 70px;
    ul li {
      cursor: pointer;
      position: relative;
      float: left;
      margin-right: 20px;
      font-size: 16px;
      color: #4f4f4f;
    }
    ul li.colors {
      &::after {
        content: ' ';
        position: absolute;
        left: 0;
        bottom: 20px;
        width: 64px;
        height: 2px;
        background: #4f4f4f;
      }
    }
  }
  .login_input {
    .input_block {
      margin-bottom: 20px;
      width: 412px;
      height: 54px;
      background: #f4f4f4;
      border-radius: 4px;
      padding: 0 15px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      span {
        cursor: pointer;
        padding-left: 20px;
        color: #4f4f4f;
        font-size: 16px;
      }
      input {
        flex: 1;
        outline: none;
        background: #f4f4f4;
        border: 1px solid #f4f4f4;
        margin-left: 20px;
        font-size: 16px;
        color: #4f4f4f;
      }
      .btn {
        font-size: 14px;
        cursor: pointer;
        color: #ec9221;
        &.disabled {
          color: #aaa;
        }
      }
    }
  }
  .login_btn {
    cursor: pointer;
    color: #fff;
    background: #ec9221;
    width: 100%;
    height: 51px;
    line-height: 51px;
    border-radius: 4px;
    text-align: center;
    a {
      font-size: 16px;
      color: #fff;
    }
  }
  .login_btn_b {
    text-align: right;
    padding: 15px 0 24px;
    a {
      font-size: 14px;
      color: #aaa;
      margin-left: 15px;
    }
    a:hover {
      color: #ec9221;
    }
  }
}
select {
  background: #f4f4f4;
  border-color: #f4f4f4;
  margin-left: 10px;
}
.tips {
  margin-top: 15px;
  font-size: 13px;
  color: #4f4f4f;
  a {
    color: #ec9221;
  }
}
</style>